import React, { useState, useEffect, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import { supabase } from '../utils/supabaseClient.js'; // NEW IMPORT
import box from '../assets/no.jpg';
import ProductSEO from './ProductSEO.js';



import { Toast } from 'react-bootstrap';

const ProductDetails = () => {
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [browsingHistory, setBrowsingHistory] = useState([]);
  const [relatedProducts, setRelatedProducts] = useState([]);
   const [showToast, setShowToast] = useState(false);
  // New: Currency & Phone
  const [ setCurrencyCode] = useState('USD');
  const [phoneNumber, setPhoneNumber] = useState('+1 (307) 316-9243'); 

  const historyRef = useRef(null);
  const relatedRef = useRef(null);

  

  const { id } = useParams();
// --- 1. DETECT LOCATION (Phone Number) ---
useEffect(() => {
    const setContactInfo = async () => {
      try {
        // Switching to 'ipwho.is' which allows browser requests (CORS friendly)
        const response = await fetch('https://ipwho.is/');
        const data = await response.json();
        
        // ipwho.is returns 'country_code' just like the other one
        if (data.country_code === 'BD') {
          setPhoneNumber('+880 1938-775447');
        } else {
          setPhoneNumber('+1 (561) 925-7771');
        }
      } catch (error) {
        console.warn('Location check failed, defaulting to US number.');
        // No need to do anything, default is already set to US
      }
    };
    setContactInfo();
  }, []);

  useEffect(() => {
    const fetchProduct = async () => {
        setLoading(true);
        
        // 1. Fetch Single Product from Supabase
        const { data, error } = await supabase
            .from('products')
            .select('*')
            .eq('id', id)
            .single();

        if (error || !data) {
            console.error("Product not found", error);
            setLoading(false);
            return;
        }

        // 2. Map Data (DB -> App format)
        const fetchedProduct = {
            ...data,
            name: data.title,
            imageUrls: data.image_urls || [],
            keywords: data.keywords || []
        };

        setProduct(fetchedProduct);
        setLoading(false);

        // 3. History Logic (Kept exactly the same as your old code)
        const history = JSON.parse(localStorage.getItem('browsingHistory')) || [];
        if (!history.some(item => item.id === fetchedProduct.id)) {
            history.push(fetchedProduct);
            if (history.length > 10) history.shift();
            localStorage.setItem('browsingHistory', JSON.stringify(history));
        }
        setBrowsingHistory(history);
    };

    fetchProduct();
  }, [id]);
 

// NEW: Fetch Related Products (Efficiently)
  useEffect(() => {
    const fetchRelated = async () => {
      if (!id) return;
      
      const productId = parseInt(id);

      // Ask Supabase: "Give me products where ID is roughly near this one"
      // We use .gte (Greater Than or Equal) and .lte (Less Than or Equal)
      const { data, error } = await supabase
        .from('products')
        .select('id, title, price, image_urls, category') // Select only what we need for the card
        .gte('id', productId - 5) // Grab some before
        .lte('id', productId + 25) // Grab some after
        .neq('id', productId) // Exclude the current product
        .limit(12); // Just show 12 related items

      if (!error && data) {
        // Map the DB names to your App names (image_urls -> imageUrls)
        const mappedRelated = data.map(p => ({
          ...p,
          name: p.title,
          imageUrls: p.image_urls || [],
          // Handle cases where category might be missing
          category:  p.category || 'Uncategorized' 
        }));
        setRelatedProducts(mappedRelated);
      }
    };

    fetchRelated();
  }, [id]);

  const addToCart = () => {
    const cart = JSON.parse(localStorage.getItem('cart')) || [];
    const existingProductIndex = cart.findIndex(item => item.id === product.id);
    
    if (existingProductIndex !== -1) {
      cart[existingProductIndex].quantity += 1;
    } else {
      cart.push({ ...product, quantity: 1 });
    }

    localStorage.setItem('cart', JSON.stringify(cart));
    setShowToast(true);
 
  };

  const handleImageError = (e) => {
    e.target.src = box; // Fallback image URL
  };

  const scrollLeft = () => {
    if (historyRef.current) {
      historyRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (historyRef.current) {
      historyRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };

  const scrollLeftRelated = () => {
    if (relatedRef.current) {
      relatedRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    }
  };

  const scrollRightRelated = () => {
    if (relatedRef.current) {
      relatedRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };

  const truncateName = (name) => {
    return name.length > 15 ? name.substring(0, 15) + '...' : name;
  };
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (loading) {
    return <div className="container mt-5">Loading product details...</div>;
  }

  if (!product) {
    return <div className="container mt-5">Product not found</div>;
  }

  return (
    <div className="container mt-5">
      <ProductSEO product={product} />

      <div className="row">
        <div className="col-md-6">
          <div className="product-image-container">
            <img 
              src={product.imageUrls[currentImageIndex]} 
              alt={`${product.name} - ${currentImageIndex + 1}`} 
              className="img-fluid product-image"
              onError={handleImageError}
            />
          </div>
          <div className="mt-3 d-flex justify-content-center">
            {product.imageUrls.map((url, index) => (
              <img 
                key={index}
                src={url} 
                alt={`${product.name} thumbnail ${index + 1}`}
                className={`thumbnail-image ${index === currentImageIndex ? 'active' : ''}`}
                onClick={() => setCurrentImageIndex(index)}
                onError={handleImageError}
              />
            ))}
          </div>
        </div>
        <div className="col-md-6">
          <h1>{product.name}</h1>
           <p className="text--muted">Category: <Link to={`/category/${encodeURIComponent(product.category)}`} >{product.category}</Link> </p> 
          <p className="text--muted">ID: {product.id}</p>
          <p>{product.description}</p>
          <h3>Price: ${product.price}</h3>

        
          <button className="btn btn-primary mt-3" onClick={addToCart}>Add to Cart</button>
             <Toast
        onClose={() => setShowToast(false)}
        show={showToast}
        delay={10000}
        autohide
        style={{
          position: 'fixed',
          bottom: 20,
          right: 20,
        }}
      >
        <Toast.Header>
          <strong className="me-auto">Cart Update</strong>
        </Toast.Header>
        <Toast.Body>Product added to cart!</Toast.Body>
      </Toast>
     
         <br></br>
          <h4> </h4>
          <br></br>
          <h4>Add to Cart to Request for Quote and get a better Price!</h4>
          <br></br>
          
        </div>
         
        <p>Exciting News from <a href={`https://store.trustglobal.com.bd/product/${Number(product.id) + 1}`}>
Trust Global</a> !</p>

<p>We're thrilled to announce that <strong>{product.name}</strong> is now available Email us now to get yours!</p>

<p>Don't Miss Out! 
Get your hands on the amazing {product.name} today. Whether you're ready to buy or just have questions, <a href="https://trustglobal.com.bd/">Trust Global</a> is here to help!</p>

<strong>🌏 INTERNATIONAL SHIPPING</strong>

Trust Global welcomes international orders!
<p>
  <br />
  {/* PHONE NUMBER BOX */}
          <div className="alert alert-success">
            <h5>Questions? Get a Quote:</h5>
            <p className="mb-0">
                 <strong>Call:</strong>  <a href={`tel:${phoneNumber}`} className="fw-bold text-success">{phoneNumber}</a>
            </p>
             <strong>Email Us:</strong> <a href="mailto:info@trustglobal.com.bd" className="fw-bold text-success">info@trustglobal.com.bd</a>
          </div>

  

  <br />
</p>
      </div>

      {/* Browsing History Section */}
      <div className="browsing-history mt-5">
        <h4>Related Products</h4>
        <div className="history-container">
          <button onClick={scrollLeftRelated} className="btn btn-secondary scroll-btn">←</button>
          <div className="history-items" ref={relatedRef}>
            {relatedProducts.map(relatedProduct => (
              <Link to={`/product/${relatedProduct.id}`} key={relatedProduct.id} onClick={handleLinkClick} className="history-item-card">
                <div className="card">
                  <img 
                    src={relatedProduct.imageUrls[0]} 
                    className="card-img-top" 
                    alt={relatedProduct.name}
                    onError={handleImageError}
                  />
                  <div className="card-body">
                    <h5 className="card-title" title={relatedProduct.name}>
                      {truncateName(relatedProduct.name)}
                    </h5>
                    <p className="card-text">Price:  {relatedProduct.price}</p>
                    <p className="card-text">Category: {relatedProduct.category}</p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
          <button onClick={scrollRightRelated} className="btn btn-secondary scroll-btn">→</button>
        </div>
      </div>


      {/* Browsing History Section */}
      <div className="browsing-history mt-5">
        <h4>Recently Viewed Products</h4>
        <div className="history-container">
          <button onClick={scrollLeft} className="btn btn-secondary scroll-btn">←</button>
          <div className="history-items" ref={historyRef}>
            {browsingHistory.map(historyProduct => (
              <Link to={`/product/${historyProduct.id}`} key={historyProduct.id} onClick={handleLinkClick} className="history-item-card">
                <div className="card">
                  <img 
                    src={historyProduct.imageUrls[0]} 
                    className="card-img-top" 
                    alt={historyProduct.name}
                    onError={handleImageError}
                  />
                  <div className="card-body">
                    <h5 className="card-title" title={historyProduct.name}>
                      {truncateName(historyProduct.name)}
                    </h5>
                    <p className="card-text">Price: RFQ {historyProduct.price}</p>
                    <p className="card-text">Category: {historyProduct.category}</p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
          <button onClick={scrollRight} className="btn btn-secondary scroll-btn">→</button>
        </div>
      </div>

      {/* Related Products Section */}
      
    </div>
  );
};

export default ProductDetails;